import { useState } from 'react';

import { IconButton, Tooltip, TextField } from '@mui/material';
import { CheckCircleOutlined as CheckCircleIcon, CancelOutlined as CancelIcon } from '@mui/icons-material';
import Box from '@mui/material/Box';


export function SaveCancelWrapper(props) {
    const {
        value,
        saveDisabledFunc,
        handleSaveClick,
        handleCancelClick,
        children,
    } = props;

    const [ isSaving, setIsSaving ] = useState(false);

    const handleSaveClickWrapper = async () => {
        setIsSaving(true);
        await handleSaveClick(value);
        setIsSaving(false);
    }

    return <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {/* Render children with isSaving prop */}
        {children({ isSaving })}
        <Tooltip title="Save">
            <span><IconButton 
                onClick={handleSaveClickWrapper}
                disabled={isSaving || saveDisabledFunc?.(value)}
                aria-label="save-dataset-name"
            >
            <CheckCircleIcon />
            </IconButton></span>
        </Tooltip>
        <Tooltip title="Cancel">
            <span><IconButton 
                onClick={handleCancelClick}
                disabled={isSaving}
                aria-label="cancel-edit"
            >
            <CancelIcon />
            </IconButton></span>
        </Tooltip>
    </Box>
}


function UpdateTextField(props) {
    const {
        initialValue,
        valueLabel,
        helperTextFunc,
        handleSaveClick,
        handleCancelClick,
    } = props;

    const [ value, setValue ] = useState(initialValue || '');
    
    return <SaveCancelWrapper
        value={value}
        saveDisabledFunc={(value) => !value.trim()}
        handleSaveClick={handleSaveClick}
        handleCancelClick={handleCancelClick}
    >
        {({ isSaving }) => <TextField
                error={value === ''}
                required
                fullWidth
                variant="filled"
                label={valueLabel}
                value={value}
                helperText={helperTextFunc(value)}
                onChange={(e) => setValue(e.target.value)}
                disabled={isSaving} // Injected from parent component
                sx={{ width: '350px' }}
                data-cy="dataset-name-input"
            />
        }
    </SaveCancelWrapper>
}

export default UpdateTextField;